import styled from 'styled-components'
import theme, {colors} from '../../../../styles/theme'

export const CardBox = styled.div`
  background: ${colors.bksGray80};
  border: 1px solid #ebeffc;
  border-radius: 2px;
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

  ${theme.breakpoints.down('md')} {
    margin-top: 24px;
  }
`

export const CardTitle = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  display: flex;
  gap: 8px;
  font-weight: 400;
  align-items: center;

  && img {
    width: 24px;
    height: 24px;
  }
`

export const Divider = styled.div`
  background-color: #d9d9d9;
  box-sizing: border-box;
  height: 1px;
  margin: 16px 0;
`
export const CardText = styled.p`
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
`

export const CardButtonBox = styled.div`
  margin-top: 16px;

  display: flex;
  flex-flow: column;
  gap: 16px;

  && button {
    width: 100%;
  }

  && a {
    width: 100%;
  }
`
